import { render, staticRenderFns } from "./ImageRecognition.vue?vue&type=template&id=d45e39b2&"
import script from "./ImageRecognition.vue?vue&type=script&lang=js&"
export * from "./ImageRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports